import { render, staticRenderFns } from "./syPrivacy.vue?vue&type=template&id=38ad9fcb&scoped=true&"
import script from "./syPrivacy.vue?vue&type=script&lang=js&"
export * from "./syPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./syPrivacy.vue?vue&type=style&index=0&id=38ad9fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad9fcb",
  null
  
)

export default component.exports